<script setup lang="ts">
import { useRoute } from "vue-router";
import { CircleLoader } from "lorga-ui";
import WhiteBox from "@/features/fahrer/components/WhiteBox.vue";
import useAuftrag from "../api/useAuftrag";
import AbrechnungAuftragFahrer from "../components/AbrechnungAuftragFahrer.vue";
import AbrechnungAuftragBreit from "../components/AbrechnungAuftragBreit.vue";

const route = useRoute();

const { auftrag, query } = useAuftrag(route.params.auftragId as string);
</script>

<template>
  <div class="p-5 px-6 bg-gray-500">
    <div v-if="!auftrag">
      <CircleLoader class="text-white" />
    </div>
    <div v-else>
      <div class="space-y-5">
        <WhiteBox class="max-w-2xl">
          <AbrechnungAuftragBreit
            :auftrag="auftrag"
            no-link
            :query="query"
            class="[&_.abrechnen-block]:hidden"
          />
          <template #heading>
            <h1 class="text-xl font-bold">Auftrag</h1>
          </template>
        </WhiteBox>
        <template v-for="fahrer in auftrag.alle_fahrer_ids" :key="fahrer">
          <AbrechnungAuftragFahrer
            :auftrag-id="auftrag.id"
            :fahrer-id="fahrer"
            :auftrag-abholung="auftrag.abholung.datum"
            :query="query"
          />
        </template>
      </div>
    </div>
  </div>
</template>
